<template>
	<div class="wzry_content">
		<div class="wzry_form">
			<div class="utitle">
				召唤师你好1,
				<br />
				欢迎进入虚贝账号评估系统
			</div>
			<div class="form-input">
				<div class="finput" @click="toShow">
					<span class="num">英雄数量</span>
					<span class="val">
						<em>{{ heroNumber.text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
				<div class="finput" @click="toShow2">
					<span class="num">皮肤数量</span>
					<span class="val">
						<em>{{ skinNumber.text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow3">
					<span class="num">年限皮肤数</span>
					<span class="val">
						<em>{{ yearSkinNumber.text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow4">
					<span class="num">限定皮肤数</span>
					<span class="val">
						<em>{{ limitNumber.text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>

				<div class="finput" @click="toShow5">
					<span class="num">段位</span>
					<span class="val">
						<em>{{ heroLevel.text }}</em>
						<img src="/static/images/jt.png" />
					</span>
				</div>
			</div>
		</div>

		<div class="ftBtn">
			<router-link to="/" class="fh"><img src="/static/images/returnBtn.png" /></router-link>
			<div class="gz" @click="guzhi"><img src="/static/images/gzBtn.png" /></div>
		</div>

		<vue-pickers
			:show="show"
			:columns="columns"
			:isRemember="true"
			:selectData="pickData"
			@cancel="close"
			@confirm="confirmFn"
		></vue-pickers>
		<div class="mask" v-if="isMask"></div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { Toast } from 'mint-ui';

const data1 = [
	{ text: '0-30', value: '720' },
	{ text: '31-60', value: '2640' },
	{ text: '61-90', value: '3600' },
	{ text: '91-120', value: '5040' },
	{ text: '121-140', value: '6480' },
	{ text: '140以上', value: '6768' }
];
const data2 = [
	{ text: '0-200', value: '3740' },
	{ text: '201-400', value: '17340' },
	{ text: '401-600', value: '34000' },
	{ text: '601-800', value: '47600' },
	{ text: '800以上', value: '60248' }
];

const data3 = [
	{ text: '0~1', value: '900' },
	{ text: '2~3', value: '1800' },
	{ text: '4~5', value: '4500' },
	{ text: '6~7', value: '5400' },
	{ text: '8及以上', value: '7200' }
];

const data4 = [
	{ text: '0-8', value: '1200' },
	{ text: '9~16', value: '2600' },
	{ text: '17~24', value: '3800' },
	{ text: '25~32', value: '5600' },
	{ text: '33以上', value: '6600' }
];

const data5 = [
	{ text: '青铜', value: '50' },
	{ text: '白银', value: '150' },
	{ text: '黄金', value: '300' },
	{ text: '铂金', value: '500' },
	{ text: '钻石', value: '1500' },
	{ text: '大师', value: '2000' },
	{ text: '最强王者', value: '5000' }
];

// 英雄数量
const heroNumber = { text: '0-30', value: '720' };
// 皮肤数量
const skinNumber = { text: '0-200', value: '3740' };
// 年限皮肤数
const yearSkinNumber = { text: '0~1', value: '900' };
// 限定皮肤数
const limitNumber = { text: '0-8', value: '1200' };
// 段位
const heroLevel = { text: '青铜', value: '50' };

export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			isMask: false,
			show: false,
			type: 1,
			columns: 1,
			defaultData: [],
			pickData: {
				data1: []
			},
			res: {},
			showTag: {},
			showDefaultText: {},
			// 英雄数量
			heroNumber,
			// 皮肤数量
			skinNumber,
			// 年限皮肤数
			yearSkinNumber,
			// 限定皮肤数
			limitNumber,
			// 段位
			heroLevel
		};
	},
	mounted() {},
	methods: {
		close() {
			this.show = false;
		},
		confirmFn(val) {
			this.show = false;
			this.res = val;
			this.showTag = val.select1 ? val.select1 : this.showDefaultText;
			// this.defaultData = [val.select1]
		},
		toShow() {
			this.pickData.data1 = data1;
			this.showTag = this.heroNumber;
			this.showDefaultText = heroNumber;
			this.show = true;
		},
		toShow2() {
			this.pickData.data1 = data2;
			this.showTag = 'skinNumber';
			this.showDefaultText = skinNumber.text;
			this.show = true;
		},
		toShow3() {
			this.pickData.data1 = data3;
			this.showTag = 'yearSkinNumber';
			this.showDefaultText = yearSkinNumber.text;
			this.show = true;
		},
		toShow4() {
			this.pickData.data1 = data4;
			this.showTag = 'limitNumber';
			this.showDefaultText = limitNumber.text;
			this.show = true;
		},
		toShow5() {
			this.pickData.data1 = data5;
			this.showTag = 'heroLevel';
			this.showDefaultText = heroLevel.text;
			this.show = true;
		},
		guzhi() {
			var guzhi =
				Number(this.hero_defaultData[0].value) +
				Number(this.skin_defaultData[0].value) +
				Number(this.year_defaultData[0].value) +
				Number(this.limit_defaultData[0].value) +
				Number(this.dw_defaultData[0].value);
			this.$router.push({ path: '/animation?id=2&username=' + this.username + '&amountValue=' + guzhi });
		}
	}
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.wzry_content {
	width: 10rem;
	margin: 0 auto;
	background: #1d2425 url(/static/images/yxlm.jpg) no-repeat;
	background-size: 100% auto;
	.wzry_form {
		padding-top: px2rem(260rem);
		padding-bottom: px2rem(165rem);
		.utitle {
			color: #b2fafd;
			font-size: px2rem(40rem);
			padding: 0 px2rem(70rem);
			margin-bottom: px2rem(64rem);
			letter-spacing: 1px;
			font-weight: bold;
		}
		.form-input {
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #223034;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				overflow: hidden;
				margin-bottom: px2rem(30rem);
				.num {
					color: #8ab9c3;
					float: left;
				}
				.val {
					color: #e8fefd;
					float: right;
					em {
						font-style: normal;
						padding-right: px2rem(20rem);
						opacity: 0.7;
					}
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
					}
				}
			}
		}
	}
	.ftBtn {
		display: flex;
		background: #000;
		padding: px2rem(20rem) 0;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		.fh {
			flex: 1;
			margin-left: px2rem(10rem);
			img {
				width: px2rem(252rem);
				height: px2rem(106rem);
			}
		}
		.gz {
			margin-right: px2rem(20rem);
			img {
				width: px2rem(436rem);
				height: px2rem(105rem);
			}
		}
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.wzry_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.wzry_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.wzry_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.wzry_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.wzry_content /deep/ .larea_finish {
	color: #ffddb5;
}

.wzry_content /deep/ .area_btn_box:before,
.wzry_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}

.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	background: #000;
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/yxlm3.vue